import { render, staticRenderFns } from "./HistSensor.vue?vue&type=template&id=227cda41&"
import script from "./HistSensor.vue?vue&type=script&lang=ts&"
export * from "./HistSensor.vue?vue&type=script&lang=ts&"
import style0 from "./HistSensor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports